import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, Bell, LogOut, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ isSidebarOpen, setIsSidebarOpen, notifications }) => {
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [driver, setDriver] = useState(null);
  const navigate = useNavigate();

  // Fetch driver data from local storage
  useEffect(() => {
    const driverData = JSON.parse(localStorage.getItem('driverData'));
    if (driverData) {
      setDriver(driverData);
    }
  }, []);

  // Get initials from name
  const getInitials = (name) => {
    const names = name.split(' ');
    const initials = names.map((n) => n[0]).join('');
    return initials.toUpperCase();
  };

  // Handle logout
  const handleLogout = () => {
    // Remove driver data and token from localStorage
    localStorage.removeItem('driverData');
    localStorage.removeItem('driverToken');
    
    // Redirect to login page
    navigate('/driver/login');
  };

  return (
    <div className="bg-white shadow-md p-4">
      <div className="flex items-center justify-between">
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="p-2 rounded-lg hover:bg-gray-100"
        >
          <Menu className="w-6 h-6 text-gray-600" />
        </button>

        <div className="flex items-center space-x-4">
          <div className="relative">
            <button
              onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
              className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-100"
            >
              {/* Display profile image if available, otherwise show initials */}
              {driver?.profileImage ? (
                <img
                  src={driver.profileImage}
                  alt="Profile"
                  className="w-8 h-8 rounded-full object-cover"
                />
              ) : (
                <div className="w-8 h-8 bg-emerald-600 rounded-full flex items-center justify-center">
                  <span className="text-white font-medium">
                    {driver?.name ? getInitials(driver.name) : 'JD'}
                  </span>
                </div>
              )}

              <div className="text-gray-700 text-left">
                <span className="block font-medium">
                  {driver?.name || 'John Doe'}
                </span>
                <span className="text-sm text-gray-500">
                  {driver?.email || 'example@email.com'}
                </span>
              </div>
              <ChevronDown className="w-4 h-4 text-gray-600" />
            </button>

            <AnimatePresence>
              {isProfileDropdownOpen && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-10"
                >
                  <button 
                    onClick={handleLogout}
                    className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100 flex items-center space-x-2"
                  >
                    <LogOut className="w-4 h-4" />
                    <span>Sign Out</span>
                  </button>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;